export const appMixin = {
  data() {
    return {
      appName: 'PapiBang',
      appStoreLink: 'itms-apps://itunes.apple.com/app/id6746687949',
      primaryColor: '#7D52F4',
      termsOfService: 'https://akaliai.com/desktop/terms_of_service',
      privacyPolicy: 'https://akaliai.com/desktop/privacy_policy',
      email: "march2025@sina.com",
      org: '',
      orgAdress: '',
      discord: 'https://discord.gg/sjWdYEAUYx',
      shopLink: {
        pre: 'https://pre-shop.cozytaps.com',
        online: 'https://shop.cozytaps.com'
      }
    }
  },

  methods: {
    getShopDomain() {
      return this.shopLink[APP_ENV.VUE_APP_ENVIRONMENT] || this.shopLink.pre;
    }
  }
}